// src/pages/Public/LandingPage/v2/i18n/landingStrings.js
//
// Diccionario i18n de la landing publica de REVI (ES/EN/FR).
// SOLO afecta a la landing (el resto del portal REVI sigue en espanol).
// Contenido en castellano/frances/ingles correcto (UTF-8, con tildes): son textos
// visibles para el usuario final, no identificadores de codigo.
//
// Estructura: una clave plana por cadena, replicada en los 3 idiomas (mismas claves).
// Textos EN/FR provienen del frontal nuevo (FrontalReviNew) verificado.

export const LANDING_STRINGS = {
  es: {
    // Navegacion
    whatIs: "¿Qué es?",
    therapies: "Terapias",
    validation: "Validación",
    pillars: "Pilares",
    proAccess: "Acceso Profesionales",
    requestInfo: "Solicitar información",

    // Hero
    techTag: "Tecnología Asistencial 2026",
    heroTitle1: "Innovación Clínica y Bienestar con",
    heroTitle2: "Realidad Virtual",
    heroDesc:
      "Transformamos la atención sociosanitaria mediante intervenciones inmersivas personalizables, rigurosas y de fácil acceso desde navegador.",
    heroCert: "Aval científico y aprobación ética institucional.",

    // ¿Qué es?
    whatIsText:
      "Una herramienta innovadora que potencia la práctica terapéutica. Combina tecnología inmersiva, análisis de datos y contenidos adaptados para facilitar intervenciones en bienestar emocional, estimulación cognitiva e integración afectiva.",

    // Alianzas academicas
    academicTag: "Respaldo Institucional",
    academicTitle: "Alianzas Académicas y Científicas",
    academicDesc:
      "Un proyecto nacido de la colaboración con instituciones líderes en salud y educación.",
    partner1Role: "Investigación",
    partner2Role: "Ciencia",
    partner3Role: "Socio Clínico",
    partner4Role: "Social",

    // Clientes
    trustTag: "Confían en REVI para impulsar el bienestar",
    reviPartner: "REVI Partner",

    // Terapias
    therapiesTag: "Especialidades",
    therapiesTitle: "Soluciones de Intervención",
    therapiesDesc:
      "Nuestra plataforma ofrece módulos especializados para abordar de forma integral la salud de los residentes.",
    therapy1Title: "Estimulación Cognitiva",
    therapy1Desc:
      "Terapia focalizada en el mantenimiento de capacidades cognitivas con monitorización clínica en tiempo real.",
    therapy2Title: "Reminiscencia",
    therapy2Desc:
      "Viajes virtuales a lugares y épocas significativas para trabajar la identidad y la memoria biográfica.",
    therapy3Title: "Motricidad",
    therapy3Desc:
      "Actividades de rehabilitación física y coordinación adaptadas a diferentes niveles de capacidad motora.",
    therapy4Title: "Intervención Psicosocial",
    therapy4Desc:
      "Programas grupales para fortalecer la cohesion social y prevenir la soledad no deseada.",
    therapy5Title: "Terapias Expresivas",
    therapy5Desc:
      "Herramientas artísticas y creativas inmersivas para la gestión afectiva y la expresión emocional.",
    therapy6Title: "Relajación",
    therapy6Desc:
      "Entornos de paz y técnicas de relajación guiada para reducir la ansiedad y el estrés.",

    // Validacion
    validationTag: "Autonomía y Rigor Clínico",
    validationTitle: "Gestión de Contenidos y Evaluación Científica",
    validationDesc:
      "REVI permite a los profesionales diseñar sesiones a medida e integrar instrumentos de evaluación estandarizados. Obtenga resultados inmediatos y gráficas de evolución clínica para cada residente de forma automatizada.",
    val1Title: "Líder Europeo: +150 Experiencias",
    val1Desc:
      "La mayor biblioteca de entornos de realidad virtual de Europa, listos para su integración inmediata.",
    val2Title: "Creación y Ajuste",
    val2Desc:
      "Libertad total para configurar cada sesión según los objetivos terapéuticos específicos.",
    val3Title: "Evaluación Integrada",
    val3Desc:
      "Incorpore tests de Lobo, Barthel o Ryff dentro de las terapias para medir impacto real.",
    val4Title: "Gráficas de Evolución",
    val4Desc:
      "Visualice el progreso clínico mediante reportes automáticos y analítica avanzada.",
    valBadge1: "+150 Entornos",
    valBadge2: "Validación Real",

    // Pilares (R-E-V-I)
    pillarsTag: "Metodología REVI",
    pillarsTitle: "Los Pilares Terapéuticos",
    pillar1L: "R",
    pillar1Title: "enovación",
    pillar1Desc:
      "Ofrece experiencias estimulantes e innovadoras que invitan a explorar, aprender y mantenerse activas.",
    pillar2L: "E",
    pillar2Title: "mociones",
    pillar2Desc:
      "Prioriza el bienestar emocional, generando momentos de alegría, serenidad y entusiasmo.",
    pillar3L: "V",
    pillar3Title: "aloración",
    pillar3Desc:
      "Fomenta la autoestima, el respeto y la confianza, poniendo en valor la historia de vida.",
    pillar4L: "I",
    pillar4Title: "nteracción",
    pillar4Desc:
      "Promueve comunicación fluida y activa, generando vínculos sociales colaborativos.",

    // Valor para la institucion + dossier
    valueTitle1: "Valor para su",
    valueTitle2: "Institución",
    valOptTitle: "Optimización de Costes",
    valOptDesc:
      "Disminución de la polifarmacia y mejora de la eficiencia asistencial.",
    valInnTitle: "Innovación y Prestigio",
    valInnDesc:
      "Lidere la transformación digital con tecnología de vanguardia.",
    valCareTitle: "Cuidado Integral",
    valCareDesc:
      "Atención centrada en la persona, adaptable a múltiples patologías.",
    futureTitle: "Preparados para el futuro",
    futureDesc:
      "REVI permite a los centros satisfacer las expectativas de un mercado que valora la tecnología humana y la excelencia en el cuidado geriátrico.",
    downloadDossier: "Descargar Dossier",

    // Award SilverEco
    awardTag: "Reconocimientos",
    awardTitle: "SilverEco International Awards 2026",
    awardCategory:
      "Nominados en la categoría: AgeTech, AI & Digital Innovation for Ageing Well Award",

    // CTA
    ctaTitle1: "Impulse el",
    ctaTitle2: "bienestar",
    ctaTitle3: "en su centro",
    ctaDesc:
      "Solicite información hoy mismo y descubra la versatilidad técnica de REVI.",

    // Footer
    footerDesc:
      "La plataforma definitiva para la salud cognitiva e inmersiva de la tercera edad.",
    resTitle: "Recursos",
    res1: "Repositorio VR",
    res2: "Herramientas",
    legalTitle: "Legal",
    legal1: "Privacidad",
    legal2: "Ética",
    companyTitle: "Empresa",
    comp1: "Educa360",
    comp2: "Contacto",
    copyright:
      "© 2026 EDUCA360 S.L. · REVI PROJECT · INNOVACIÓN CON IMPACTO GLOBAL",

    // Formulario de contacto (DemoModal)
    formTitle: "Solicitar Demo Institucional",
    formSubtitle:
      "Completa tus datos y nos pondremos en contacto contigo para agendar una demo.",
    formName: "Nombre y Apellidos",
    formNamePh: "Ej: Dra. Elena García",
    formCenter: "Nombre de la Institución / Residencia",
    formCenterPh: "Ej: Residencia Los Olivos",
    formEmail: "Correo Electrónico Corporativo",
    formEmailPh: "direccion@centro.com",
    formPhone: "Teléfono",
    formPhonePh: "+34 600 000 000",
    formRole: "Cargo",
    formRolePh: "Selecciona una opción",
    roleManagement: "Dirección",
    roleCoordination: "Coordinación",
    rolePsychology: "Psicología",
    roleOccTherapy: "Terapia Ocupacional",
    rolePhysio: "Fisioterapia",
    roleOther: "Otro",
    formSubmit: "Enviar Solicitud",
    formSubmitting: "Enviando...",
    formRequired: "Campo requerido",
    formEmailInvalid: "Email inválido",
    formSuccess: "¡Solicitud enviada! Un especialista te contactará en breve.",
    formError: "Hubo un problema al enviar el formulario.",
  },

  en: {
    // Navigation
    whatIs: "What is it?",
    therapies: "Therapies",
    validation: "Validation",
    pillars: "Pillars",
    proAccess: "Professionals Access",
    requestInfo: "Request Information",

    // Hero
    techTag: "Assistive Technology 2026",
    heroTitle1: "Clinical Innovation & Wellbeing with",
    heroTitle2: "Virtual Reality",
    heroDesc:
      "We transform social and healthcare through customisable, rigorous, and easily accessible immersive interventions directly from your browser.",
    heroCert: "Scientific endorsement and institutional ethical approval.",

    // What is it?
    whatIsText:
      "An innovative tool that enhances therapeutic practice. It combines immersive technology, data analysis, and tailored content to facilitate interventions in emotional wellbeing, cognitive stimulation, and affective integration.",

    // Academic partnerships
    academicTag: "Institutional Backing",
    academicTitle: "Academic & Scientific Partnerships",
    academicDesc:
      "A project born from collaboration with leading institutions in health and education.",
    partner1Role: "Research",
    partner2Role: "Science",
    partner3Role: "Clinical Partner",
    partner4Role: "Social",

    // Clients
    trustTag: "Trusted by REVI to boost wellbeing",
    reviPartner: "REVI Partner",

    // Therapies
    therapiesTag: "Specialities",
    therapiesTitle: "Intervention Solutions",
    therapiesDesc:
      "Our platform offers specialised modules for comprehensive care of residents' health.",
    therapy1Title: "Cognitive Stimulation",
    therapy1Desc:
      "Therapy focused on maintaining cognitive abilities with real-time clinical monitoring.",
    therapy2Title: "Reminiscence",
    therapy2Desc:
      "Virtual journeys to significant places and eras to work on identity and biographical memory.",
    therapy3Title: "Motor Skills",
    therapy3Desc:
      "Physical rehabilitation and coordination activities adapted to different levels of motor capacity.",
    therapy4Title: "Psychosocial Intervention",
    therapy4Desc:
      "Group programmes to strengthen social cohesion and prevent unwanted loneliness.",
    therapy5Title: "Expressive Therapies",
    therapy5Desc:
      "Immersive artistic and creative tools for affective management and emotional expression.",
    therapy6Title: "Relaxation",
    therapy6Desc:
      "Peaceful environments and guided relaxation techniques to reduce anxiety and stress.",

    // Validation
    validationTag: "Autonomy and Clinical Rigour",
    validationTitle: "Content Management & Scientific Evaluation",
    validationDesc:
      "REVI enables professionals to design bespoke sessions and integrate standardised assessment tools. Obtain instant results and automated clinical progress charts for each resident.",
    val1Title: "European Leader: +150 Experiences",
    val1Desc:
      "The largest library of virtual reality environments in Europe, ready for immediate integration.",
    val2Title: "Creation & Adjustment",
    val2Desc:
      "Total freedom to configure each session according to specific therapeutic objectives.",
    val3Title: "Integrated Assessment",
    val3Desc:
      "Incorporate Lobo, Barthel, or Ryff tests within therapies to measure actual impact.",
    val4Title: "Progress Charts",
    val4Desc:
      "Visualise clinical progress through automated reports and advanced analytics.",
    valBadge1: "+150 Environments",
    valBadge2: "Real Validation",

    // Pillars (R-E-V-I)
    pillarsTag: "REVI Methodology",
    pillarsTitle: "The Therapeutic Pillars",
    pillar1L: "R",
    pillar1Title: "enewal",
    pillar1Desc:
      "Offers stimulating and innovative experiences that invite exploration, learning, and staying active.",
    pillar2L: "E",
    pillar2Title: "motions",
    pillar2Desc:
      "Prioritises emotional wellbeing, generating moments of joy, serenity, and enthusiasm.",
    pillar3L: "V",
    pillar3Title: "alidation",
    pillar3Desc:
      "Fosters self-esteem, respect, and confidence, placing value on one's life story.",
    pillar4L: "I",
    pillar4Title: "nteraction",
    pillar4Desc:
      "Promotes fluid and active communication, generating collaborative social bonds.",

    // Institutional value + dossier
    valueTitle1: "Value for your",
    valueTitle2: "Institution",
    valOptTitle: "Cost Optimisation",
    valOptDesc: "Reduction of polypharmacy and improvement in care efficiency.",
    valInnTitle: "Innovation & Prestige",
    valInnDesc: "Lead digital transformation with cutting-edge technology.",
    valCareTitle: "Comprehensive Care",
    valCareDesc: "Person-centred care, adaptable to multiple pathologies.",
    futureTitle: "Ready for the future",
    futureDesc:
      "REVI allows centres to meet the expectations of a market that values human-centric technology and excellence in geriatric care.",
    downloadDossier: "Download Dossier",

    // Award SilverEco
    awardTag: "Awards & Recognition",
    awardTitle: "SilverEco International Awards 2026",
    awardCategory:
      "Nominated in the category: AgeTech, AI & Digital Innovation for Ageing Well Award",

    // CTA
    ctaTitle1: "Boost",
    ctaTitle2: "wellbeing",
    ctaTitle3: "in your centre",
    ctaDesc:
      "Request information today and discover the technical versatility of REVI.",

    // Footer
    footerDesc:
      "The definitive platform for cognitive and immersive health in older adults.",
    resTitle: "Resources",
    res1: "VR Repository",
    res2: "Tools",
    legalTitle: "Legal",
    legal1: "Privacy",
    legal2: "Ethics",
    companyTitle: "Company",
    comp1: "Educa360",
    comp2: "Contact",
    copyright:
      "© 2026 EDUCA360 S.L. · REVI PROJECT · INNOVATION WITH GLOBAL IMPACT",

    // Contact form (DemoModal)
    formTitle: "Request an Institutional Demo",
    formSubtitle:
      "Fill in your details and we will get in touch to schedule a demo.",
    formName: "Full Name",
    formNamePh: "e.g. Dr. Elena García",
    formCenter: "Institution / Care Home Name",
    formCenterPh: "e.g. Los Olivos Care Home",
    formEmail: "Corporate Email",
    formEmailPh: "director@centre.com",
    formPhone: "Phone",
    formPhonePh: "+34 600 000 000",
    formRole: "Role",
    formRolePh: "Select an option",
    roleManagement: "Management",
    roleCoordination: "Coordination",
    rolePsychology: "Psychology",
    roleOccTherapy: "Occupational Therapy",
    rolePhysio: "Physiotherapy",
    roleOther: "Other",
    formSubmit: "Send Request",
    formSubmitting: "Sending...",
    formRequired: "Required field",
    formEmailInvalid: "Invalid email",
    formSuccess: "Request sent! A specialist will contact you shortly.",
    formError: "There was a problem submitting the form.",
  },

  fr: {
    // Navigation
    whatIs: "Qu'est-ce que c'est ?",
    therapies: "Thérapies",
    validation: "Validation",
    pillars: "Piliers",
    proAccess: "Accès Professionnels",
    requestInfo: "Demander des infos",

    // Hero
    techTag: "Technologie d'Assistance 2026",
    heroTitle1: "Innovation Clinique et Bien-être avec",
    heroTitle2: "la Réalité Virtuelle",
    heroDesc:
      "Nous transformons les soins socio-sanitaires grâce à des interventions immersives personnalisables, rigoureuses et facilement accessibles depuis un navigateur.",
    heroCert:
      "Approbation scientifique et validation éthique institutionnelle.",

    // Qu'est-ce que c'est ?
    whatIsText:
      "Un outil innovant qui renforce la pratique thérapeutique. Il associe la technologie immersive, l'analyse de données et des contenus adaptés pour faciliter les interventions en matière de bien-être émotionnel, de stimulation cognitive et d'intégration affective.",

    // Partenariats academiques
    academicTag: "Soutien Institutionnel",
    academicTitle: "Partenariats Académiques et Scientifiques",
    academicDesc:
      "Un projet né de la collaboration avec des institutions de pointe dans les domaines de la santé et de l'éducation.",
    partner1Role: "Recherche",
    partner2Role: "Science",
    partner3Role: "Partenaire Clinique",
    partner4Role: "Social",

    // Clients
    trustTag: "Ils font confiance à REVI pour favoriser le bien-être",
    reviPartner: "Partenaire REVI",

    // Therapies
    therapiesTag: "Spécialités",
    therapiesTitle: "Solutions d'Intervention",
    therapiesDesc:
      "Notre plateforme propose des modules spécialisés pour une prise en charge globale de la santé des résidents.",
    therapy1Title: "Stimulation Cognitive",
    therapy1Desc:
      "Thérapie axée sur le maintien des capacités cognitives avec un suivi clinique en temps réel.",
    therapy2Title: "Réminiscence",
    therapy2Desc:
      "Voyages virtuels vers des lieux et des époques significatifs pour travailler sur l'identité et la mémoire biographique.",
    therapy3Title: "Motricité",
    therapy3Desc:
      "Activités de rééducation physique et de coordination adaptées à différents niveaux de capacité motrice.",
    therapy4Title: "Intervention Psychosociale",
    therapy4Desc:
      "Programmes de groupe pour renforcer la cohésion sociale et prévenir la solitude non désirée.",
    therapy5Title: "Thérapies Expressives",
    therapy5Desc:
      "Outils immersifs artistiques et créatifs pour la gestion affective et l'expression émotionnelle.",
    therapy6Title: "Relaxation",
    therapy6Desc:
      "Environnements paisibles et techniques de relaxation guidée pour réduire l'anxiété et le stress.",

    // Validation
    validationTag: "Autonomie et Rigueur Clinique",
    validationTitle: "Gestion de Contenu et Évaluation Scientifique",
    validationDesc:
      "REVI permet aux professionnels de concevoir des séances sur mesure et d'intégrer des outils d'évaluation standardisés. Obtenez des résultats instantanés et des graphiques d'évolution clinique pour chaque résident de manière automatisée.",
    val1Title: "Leader Européen : +150 Expériences",
    val1Desc:
      "La plus grande bibliothèque d'environnements de réalité virtuelle en Europe, prête pour une intégration immédiate.",
    val2Title: "Création et Ajustement",
    val2Desc:
      "Une liberté totale pour configurer chaque séance en fonction d'objectifs thérapeutiques précis.",
    val3Title: "Évaluation Intégrée",
    val3Desc:
      "Intégrez les tests de Lobo, Barthel ou Ryff aux thérapies pour mesurer l'impact réel.",
    val4Title: "Graphiques d'Évolution",
    val4Desc:
      "Visualisez les progrès cliniques grâce à des rapports automatisés et des analyses avancées.",
    valBadge1: "+150 Environnements",
    valBadge2: "Validation Réelle",

    // Piliers (R-E-V-I)
    pillarsTag: "Méthodologie REVI",
    pillarsTitle: "Les Piliers Thérapeutiques",
    pillar1L: "R",
    pillar1Title: "enouvellement",
    pillar1Desc:
      "Offre des expériences stimulantes et innovantes qui invitent à explorer, apprendre et rester actif.",
    pillar2L: "É",
    pillar2Title: "motions",
    pillar2Desc:
      "Donne la priorité au bien-être émotionnel, générant des moments de joie, de sérénité et d'enthousiasme.",
    pillar3L: "V",
    pillar3Title: "alorisation",
    pillar3Desc:
      "Favorise l'estime de soi, le respect et la confiance, en valorisant l'histoire de vie.",
    pillar4L: "I",
    pillar4Title: "nteraction",
    pillar4Desc:
      "Favorise une communication fluide et active, générant des liens sociaux collaboratifs.",

    // Valeur pour l'institution + dossier
    valueTitle1: "Valeur pour votre",
    valueTitle2: "Institution",
    valOptTitle: "Optimisation des Coûts",
    valOptDesc:
      "Réduction de la polymédication et amélioration de l'efficacité des soins.",
    valInnTitle: "Innovation et Prestige",
    valInnDesc:
      "Menez la transformation numérique avec une technologie de pointe.",
    valCareTitle: "Soins Intégraux",
    valCareDesc:
      "Des soins centrés sur la personne, adaptables à de multiples pathologies.",
    futureTitle: "Prêts pour l'avenir",
    futureDesc:
      "REVI permet aux centres de répondre aux attentes d'un marché qui valorise la technologie humaine et l'excellence dans les soins gériatriques.",
    downloadDossier: "Télécharger le Dossier",

    // Award SilverEco
    awardTag: "Récompenses et Reconnaissance",
    awardTitle: "SilverEco International Awards 2026",
    awardCategory:
      "Nominé dans la catégorie : AgeTech, AI & Digital Innovation for Ageing Well Award",

    // CTA
    ctaTitle1: "Stimulez le",
    ctaTitle2: "bien-être",
    ctaTitle3: "dans votre centre",
    ctaDesc:
      "Demandez des informations dès aujourd'hui et découvrez la polyvalence technique de REVI.",

    // Footer
    footerDesc:
      "La plateforme par excellence pour la santé cognitive et immersive des personnes âgées.",
    resTitle: "Ressources",
    res1: "Référentiel VR",
    res2: "Outils",
    legalTitle: "Légal",
    legal1: "Confidentialité",
    legal2: "Éthique",
    companyTitle: "Entreprise",
    comp1: "Educa360",
    comp2: "Contact",
    copyright:
      "© 2026 EDUCA360 S.L. · PROJET REVI · L'INNOVATION À IMPACT GLOBAL",

    // Formulaire de contact (DemoModal)
    formTitle: "Demander une Démo Institutionnelle",
    formSubtitle:
      "Remplissez vos coordonnées et nous vous contacterons pour planifier une démo.",
    formName: "Nom et Prénom",
    formNamePh: "ex. : Dre Elena García",
    formCenter: "Nom de l'Institution / Résidence",
    formCenterPh: "ex. : Résidence Los Olivos",
    formEmail: "E-mail Professionnel",
    formEmailPh: "direction@centre.com",
    formPhone: "Téléphone",
    formPhonePh: "+34 600 000 000",
    formRole: "Fonction",
    formRolePh: "Sélectionnez une option",
    roleManagement: "Direction",
    roleCoordination: "Coordination",
    rolePsychology: "Psychologie",
    roleOccTherapy: "Ergothérapie",
    rolePhysio: "Physiothérapie",
    roleOther: "Autre",
    formSubmit: "Envoyer la Demande",
    formSubmitting: "Envoi...",
    formRequired: "Champ requis",
    formEmailInvalid: "E-mail invalide",
    formSuccess: "Demande envoyée ! Un spécialiste vous contactera sous peu.",
    formError: "Un problème est survenu lors de l'envoi du formulaire.",
  },
};

export const SUPPORTED_LANGS = ["es", "en", "fr"];
